// removed by extract-text-webpack-plugin
module.exports = {"tracker":"Tracker__tracker"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/Tracker/Tracker.scss
// module id = 1831
// module chunks = 8